"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _recompose = require("recompose");
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var DISPLAY_NAME = 'InputRequired';
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: theme.mixins.inputRequired
  };
};
/*:: type Props = InjectSheetProvidedProps & {
  disabled: boolean,
  embedded: boolean,
  hasRequired: boolean,
  intl: Object,
  readOnly: boolean,
  required: boolean
};*/
var InputRequired = /*#__PURE__*/function (_PureComponent) {
  function InputRequired() {
    (0, _classCallCheck2.default)(this, InputRequired);
    return _callSuper(this, InputRequired, arguments);
  }
  (0, _inherits2.default)(InputRequired, _PureComponent);
  return (0, _createClass2.default)(InputRequired, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        className = _this$props.className;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.root, className),
        "data-id": "".concat(DISPLAY_NAME, "__required")
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        defaultMessage: "Required",
        description: "When present, it specifies that an input field must be filled out before submitting the form.",
        id: "input.required"
      }));
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2.default)(InputRequired, "displayName", DISPLAY_NAME);
(0, _defineProperty2.default)(InputRequired, "defaultProps", {
  disabled: false,
  embedded: false,
  hasRequired: true,
  readOnly: false,
  required: true
});
var EnhancedInputRequired = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _injectSheet.default)(Style), (0, _recompose.defaultProps)({
  disabled: false,
  embedded: false,
  hasRequired: true,
  readOnly: false,
  required: true
}), (0, _recompose.setDisplayName)(DISPLAY_NAME), (0, _recompose.branch)(function (_ref) {
  var disabled = _ref.disabled,
    embedded = _ref.embedded,
    hasRequired = _ref.hasRequired,
    readOnly = _ref.readOnly,
    required = _ref.required;
  return disabled || embedded || !hasRequired || readOnly || !required;
}, _recompose.renderNothing))(InputRequired);
EnhancedInputRequired.displayName = 'InputRequired';
var _default = exports.default = EnhancedInputRequired;
//# sourceMappingURL=InputRequired.js.map